export const RESET_SEND_PAYMENT = 'SendPayment/RESET_SEND_PAYMENT';

export const PRE_SEND_PAYMENT = 'SendPayment/PRE_SEND_PAYMENT';
export const PRE_SEND_PAYMENT_SET_DATA = 'SendPayment/PRE_SEND_PAYMENT_SET_DATA';

export const SEND_PAYMENT_NEW = 'SendPayment/SEND_PAYMENT_NEW';
export const SEND_PAYMENT_SET_DATA_NEW = 'SendPayment/SEND_PAYMENT_SET_DATA_NEW';
